/* Unico punto in cui vive la sessione del browser.
 *
 * Prima stava in sessionStorage, che e' per singola SCHEDA: aprire un link in
 * un tab nuovo — o fare "duplica scheda" — presentava un utente non
 * autenticato, che veniva rimbalzato al login pur avendo la sessione attiva
 * accanto. localStorage e' per ORIGINE, quindi condiviso fra le schede e
 * persistente alla chiusura del browser.
 *
 * Contropartita accettata: il token resta su disco fino al logout o alla
 * scadenza, invece di morire con la scheda. Il JWT ha una sua `exp` e
 * axiosInstance pulisce tutto al primo 401, quindi una sessione scaduta non
 * sopravvive alla prima chiamata.
 *
 * Ogni accesso e' protetto: in navigazione privata, o con i dati di sito
 * bloccati, il solo leggere localStorage puo' lanciare.
 */

export const TOKEN_KEY = 'accessToken';
export const ROLES_KEY = 'userRoles';

export const leggiToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY) || '';
  } catch (e) {
    return '';
  }
};

export const leggiRuoli = () => {
  try {
    return JSON.parse(localStorage.getItem(ROLES_KEY)) || [];
  } catch (e) {
    return [];
  }
};

export const salvaSessione = (token, ruoli) => {
  try {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(ROLES_KEY, JSON.stringify(ruoli || []));
  } catch (e) {
    // Senza persistenza la sessione vale per la pagina corrente: non e' un
    // motivo per far fallire il login.
  }
};

export const pulisciSessione = () => {
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(ROLES_KEY);
  } catch (e) {
    /* niente da pulire */
  }
};
